import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NotificationsService} from '@westjetairlines/wjesd-component-library';
import {BaseStepComponent} from '../base-step/base-step.component';
import {isNullOrUndefined} from 'util';
import {Iata} from '../../shared/models/iata';
import {Team} from '../../shared/models/team';
import {ValidationExpressions} from '../../shared/validation/validation.expressions';
import {WORKFLOW_DATA_SERVICE_TOKEN} from '../../shared/services/workflow-data.service';
import {TRAVEL_CREDIT_SERVICE_TOKEN} from '../../shared/services/travel-credit.service';
import {NavigationService} from '../../shared/services/navigation.service';
import {Agency} from '../../shared/models/agency';
import {TravelCreditType} from '../../shared/models/travel-credit-type';
import {TravelCreditAction} from '../../shared/models/travel-credit-action';

@Component({
  selector: 'app-agency-step',
  templateUrl: './agency-step.component.html',
  styleUrls: ['./agency-step.component.css']
})
export class AgencyStepComponent extends BaseStepComponent implements OnInit, OnDestroy {
  public iata: Iata = new Iata();
  public travelAgencyName: string;
  public travelAgentName: string;
  public salesRepAuthorization: string;
  public comments: string;
  public teams: Array<Team> = [];
  public selectedTeam = 0;
  public salesAndAgentRegex: string = ValidationExpressions.guestName;
  private agencySubscription: any;
  private iataSubscription: any;

  constructor(route: ActivatedRoute, @Inject(WORKFLOW_DATA_SERVICE_TOKEN) private workflowDataService,
              @Inject(TRAVEL_CREDIT_SERVICE_TOKEN) private travelCreditService, router: Router,
              navigationService: NavigationService,  private notificationService: NotificationsService) {
      super(route, navigationService, router);
  }

  ngOnInit() {
    let self = this;
    self.travelCreditService.getTeams().subscribe(data => {
        self.teams.push(...data as Array<Team>);

      },
      err => {
      },
      () => {
      });

    this.iataSubscription =  this.workflowDataService.getTicketingIata.subscribe(data => {
      self.iata.iataCode = isNullOrUndefined(data) || isNullOrUndefined(data.iataCode) ? null : data.iataCode;
      self.iata.iataOverride = isNullOrUndefined(data) || isNullOrUndefined(data.iataOverride) ? false : data.iataOverride;
      self.iata.iataComments = isNullOrUndefined(data) || isNullOrUndefined(data.iataComments) ? null : data.iataComments;
    });

    this.agencySubscription =  this.workflowDataService.getAgency.subscribe(data => {
      self.selectedTeam = isNullOrUndefined(data) || isNullOrUndefined(data.team) ? 0 : data.team.id;
      self.travelAgentName = isNullOrUndefined(data) || isNullOrUndefined(data.travelAgentName) ? null : data.travelAgentName;
      self.travelAgencyName = isNullOrUndefined(data) || isNullOrUndefined(data.travelAgencyName) ? null : data.travelAgencyName;
      self.salesRepAuthorization = isNullOrUndefined(data) || isNullOrUndefined(data.salesRep) ? null : data.salesRep;
      self.comments = isNullOrUndefined(data) || isNullOrUndefined(data.comments) ? null : data.comments;
    });
  }

  setModels() {
    let team = this.teams.find(r => r.id === +this.selectedTeam);
    let agency = new Agency(this.travelAgencyName, this.travelAgentName,
      this.comments, this.salesRepAuthorization, team);
    this.workflowDataService.setTicketingIata(this.iata);
    this.workflowDataService.setAgency(agency);
  }

  save() {
    let travelCreditType = this.travelCreditType.id === TravelCreditType.WaiverId ? 'waivers' : 'favours';
    this.setModels();

    this.workflowDataService.save().subscribe(data => {
      if (data.wasSuccessful) {
        this.navigationService.publishCreateStarted();
        if (this.travelCreditAction === TravelCreditAction.Add) {
          this.router.navigate([`/${travelCreditType}/transactions/` + data.value ]);
        } else {
          this.router.navigate([`/${travelCreditType}/${data.value.id}/summary`]);
        }
      } else {
        this.notificationService.error(data.brokenRules[0].message);
      }
    });
  }

  ngOnDestroy() {
    if(this.iataSubscription) {
      this.iataSubscription.unsubscribe();
    }

    if(this.agencySubscription) {
      this.agencySubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/steps/agency-step/agency-step.component.ts